import { extent } from 'd3-array'
import * as d3Scales from '@vx/scale'

import { ForestRowData } from './forest-row-data.model'
import { chartColors, colors } from '../../common/colors'

export const DEFAULT_PLOT_COLOR = colors.oriolesOrange

class ForestService {
  mapData (data, columnNames) {
    const groupColors = {}
    let colorIndex = 0

    const mappedData = data.reduce((analyses, r) => {
      r = new ForestRowData(r, columnNames)
      let analysis = analyses.find((a) => a.key === r.analysis)
      if (!analysis) {
        analysis = { key: r.analysis, label: r.analysis, groups: [] }
        analyses.push(analysis)
      }

      let group = analysis.groups.find((g) => g.key === r.group)
      if (!group) {
        let color = groupColors[r.group] || chartColors[colorIndex++]
        groupColors[r.group] = color
        group = { key: r.group, label: r.group, risk: r.risk, ciLo: r.ciLo, ciHi: r.ciHi, color }
        analysis.groups.push(group)
      }
      return analyses
    }, [])

    if (mappedData.length === 1) {
      mappedData[0].groups.forEach((group) => {
        group.color = DEFAULT_PLOT_COLOR
      })
    }

    return mappedData
  }

  getXScale ({ analyses, width, scaleType = 'scaleLinear', xValueDomain }) {
    const scale = d3Scales[scaleType]
    return scale({
      range: [0, width],
      domain: xValueDomain || getXDomain(analyses)
    })
  }
}

// Private Functions

function getXDomain (analyses) {
  const values = analyses.reduce((values, a) => {
    a.groups.forEach((g) => {
      if (g.ciLo === undefined || g.ciLo === null || g.ciHi === undefined || g.ciHi === null) {
        values.push(g.risk)
      } else {
        values.push(g.ciLo)
        values.push(g.ciHi)
      }
    })
    return values
  }, [])
  const range = extent(values)
  // Add 5% padding to both ends of the x axis
  const padding = (range[1] - range[0]) * 0.05
  return [range[0] - padding, range[1] + padding]
}

export const forestService = new ForestService()
